module.exports = __webpack_public_path__ + "img/ic-status-success@2x.85f83f00.png";